import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_TRIALGROUPITEMCATEGORIES_LOAD_BY_TRIALGROUPID,
    ITrialGroupItemCategoriesLoadByTrialGroupIdAction,
    ITrialGroupItemCategoriesLoadByTrialGroupIdFailureAction,
    ITrialGroupItemCategoriesLoadByTrialGroupIdSuccessAction,
    LoadFailure,
    LoadSuccess,
} from "../actions/trialGroupItemCategory";
import { trialGroupItemCategoryApi } from 'src/services/trialGroupItemCategory';

export const
    getTrialGroupItemCategoriesByTrialGroupIdEpic = (action$): 
    Observable<ITrialGroupItemCategoriesLoadByTrialGroupIdSuccessAction | ITrialGroupItemCategoriesLoadByTrialGroupIdFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPITEMCATEGORIES_LOAD_BY_TRIALGROUPID)
            .mergeMap((action: ITrialGroupItemCategoriesLoadByTrialGroupIdAction) => {
                return trialGroupItemCategoryApi
                    .getTrialGroupItemCategoriesByTrialGroupId(action.trialGroupId)
                    .map(response =>
                        LoadSuccess(response.trialGroupItemCategories, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    }